import axiosInstance from 'api/axiosInstance';

const updateDocument = ({
  documentId,
  ...params
}: Partial<{
  documentId: string;
  dateNumber?: number;
  tags: string[];
  name: string;
  taxId?: string;
}>) => axiosInstance.patch(`/v2/repository-documents/${documentId}`, params);

export default updateDocument;
